<template>
  <auth-shell>
    <div class="text-center">
      <div class="auth-icon-badge">
        <svg viewBox="0 0 20 20" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 10.5L8.5 15L16 5.5" stroke="#019256" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h4 class="auth-title">Email Validated!</h4>
      <p class="auth-subtitle">
        You can now use this email configuration to send emails from Ashore as your user.
      </p>
      <p class="auth-body-text">
        You're done! Great job! Feel free to close this tab.
      </p>
    </div>
  </auth-shell>
</template>

<script>
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
};
</script>
